import { useState, useEffect } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import { Lock, CheckCircle, AlertCircle } from "lucide-react";
import { PasswordInput } from "../components/shared/PasswordInput";
import { TelcaVoIPBadge } from "../components/shared/TelcaVoIPBadge";
import { toast } from "sonner";
import axios from "axios";
import { API, LOJACK_LOGO } from "../config";

const SetupPasswordPage = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get("token");
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password.length < 6) { setError("Password minimo 6 caratteri"); return; }
    if (password !== confirm) { setError("Le password non coincidono"); return; }
    setLoading(true); setError("");
    try {
      await axios.post(`${API}/dealer/setup-password`, { token, password });
      setDone(true);
      toast.success("Password creata!");
    } catch (err) {
      setError(err.response?.data?.detail || "Errore. Link non valido o scaduto.");
    } finally { setLoading(false); }
  };

  if (!token) return (
    <div className="min-h-screen bg-lojack-black flex items-center justify-center">
      <div className="text-center">
        <AlertCircle className="w-16 h-16 text-red-500 mx-auto mb-4" />
        <h2 className="text-xl font-bold text-white mb-2">Link non valido</h2>
        <Link to="/dealer" className="text-lojack-red hover:underline">Torna al login</Link>
      </div>
    </div>
  );

  if (done) return (
    <div className="min-h-screen bg-lojack-black flex items-center justify-center">
      <div className="text-center">
        <CheckCircle className="w-16 h-16 text-lojack-blue-500 mx-auto mb-4" />
        <h2 className="text-xl font-bold text-white mb-2">Password creata con successo!</h2>
        <p className="text-gray-400 mb-6">Puoi ora effettuare il login con le tue credenziali.</p>
        <button onClick={() => navigate("/dealer")} className="btn-lojack">Vai al Login</button>
      </div>
    </div>
  );

  return (
    <div className="min-h-screen bg-lojack-black flex items-center justify-center px-4" data-testid="setup-password-page">
      <div className="w-full max-w-md">
        <div className="flex items-center justify-center gap-3 mb-8">
          <img src={LOJACK_LOGO} alt="LoJack Tracker" className="h-12" />
        </div>
        <div className="bg-[#111] border border-gray-800 rounded-2xl p-8">
          <div className="flex items-center gap-3 mb-6">
            <div className="w-10 h-10 rounded-xl bg-lojack-red/10 border border-lojack-red/30 flex items-center justify-center">
              <Lock className="w-5 h-5 text-lojack-red" />
            </div>
            <div>
              <h1 className="text-xl font-bold text-white">Crea la tua Password</h1>
              <p className="text-gray-500 text-sm">Scegli una password per il tuo account venditore</p>
            </div>
          </div>
          {error && <div className="bg-red-500/10 border border-red-500/30 text-red-400 text-sm rounded-xl px-4 py-3 mb-4">{error}</div>}
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="text-gray-400 text-xs">Nuova Password *</label>
              <PasswordInput value={password} onChange={e => setPassword(e.target.value)} required minLength={6}
                className="w-full mt-1 px-4 py-3 pr-12 bg-[#0A0A0A] border border-gray-700 rounded-xl text-white focus:border-lojack-red focus:outline-none"
                placeholder="Minimo 6 caratteri" data-testid="setup-password-input" />
            </div>
            <div>
              <label className="text-gray-400 text-xs">Conferma Password *</label>
              <PasswordInput value={confirm} onChange={e => setConfirm(e.target.value)} required
                className="w-full mt-1 px-4 py-3 pr-12 bg-[#0A0A0A] border border-gray-700 rounded-xl text-white focus:border-lojack-red focus:outline-none"
                placeholder="Ripeti la password" data-testid="setup-confirm-input" />
            </div>
            <button type="submit" disabled={loading} className="w-full btn-lojack py-3 disabled:opacity-50" data-testid="setup-submit">
              {loading ? "Salvataggio..." : "Crea Password"}
            </button>
          </form>
        </div>
        <div className="text-center mt-6"><TelcaVoIPBadge /></div>
      </div>
    </div>
  );
};

export default SetupPasswordPage;